module.exports = __webpack_public_path__ + "static/img_9623-931521a45183ab75c2007fac42ae3c5b.webp";